import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const paletteDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),
  };
};
